"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taxonomies = void 0;
exports.taxonomies = {
    singlewordBenchmark: {
        name: 'Benchmark',
        source: 'singleword-benchmark',
        locales: [
            'ab',
            'cs',
            'cv',
            'da',
            'ka',
            'kab',
            'ky',
            'or',
            'rw',
            'sv',
            'zh-CN',
            'zh-HK',
        ],
    },
    covid19Spotter: {
        name: 'Covid-19 Keyword Spotter',
        source: 'du-covid-keywords',
        locales: ['rw'],
    },
};
//# sourceMappingURL=taxonomies.js.map